import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import AnimatedBackground from "@/components/AnimatedBackground";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("Şifre en az 6 karakter olmalı");
    if (password !== password2) return setError("Şifreler eşleşmiyor");
    setBusy(true);
    try {
      await register(username, password, email || undefined);
      navigate("/panel");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 py-10">
      <AnimatedBackground />
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <img
            src="/assets/gulyan-logo-tight.png"
            alt="Gulyan OSINT"
            className="w-56 md:w-64 h-auto object-contain drop-shadow-[0_0_30px_rgba(157,78,221,0.35)]"
          />
          <div className="text-[11px] tracking-[0.4em] text-[#9D4EDD] font-mono mt-2">
            KAYIT TERMİNALİ
          </div>
        </div>

        <form onSubmit={onSubmit} className="gc-card p-6 md:p-8" data-testid="register-form">
          <h1 className="font-heading text-3xl font-bold mb-1">Kayıt Ol</h1>
          <p className="text-sm text-[#A1A1AA] mb-6">Ücretsiz plan ile başlayın.</p>

          <label className="gc-label block mb-2">Kullanıcı Adı</label>
          <input
            data-testid="register-username-input"
            className="gc-input mb-4"
            placeholder="kullanici_adi"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            minLength={3}
          />

          <label className="gc-label block mb-2">E-posta (opsiyonel)</label>
          <input
            data-testid="register-email-input"
            className="gc-input mb-4"
            type="email"
            placeholder="mail@ornek.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label className="gc-label block mb-2">Şifre</label>
          <input
            data-testid="register-password-input"
            className="gc-input mb-4"
            type="password"
            placeholder="min 6 karakter"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
          />

          <label className="gc-label block mb-2">Şifre (Tekrar)</label>
          <input
            data-testid="register-password2-input"
            className="gc-input mb-4"
            type="password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
          />

          {error && (
            <div
              data-testid="register-error"
              className="text-[#9D4EDD] text-sm font-mono border border-[#9D4EDD]/40 bg-[#9D4EDD]/5 p-3 mb-4"
            >
              {error}
            </div>
          )}

          <button
            data-testid="register-submit"
            type="submit"
            disabled={busy}
            className="gc-btn-primary w-full"
          >
            {busy ? "KAYIT OLUNUYOR…" : "KAYIT OL"}
          </button>

          <div className="mt-6 text-sm text-[#A1A1AA] text-center">
            Zaten hesabınız var mı?{" "}
            <Link
              to="/login"
              data-testid="register-to-login"
              className="text-[#9D4EDD] hover:text-white"
            >
              Giriş yapın
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
